import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Collapse, Input, Popconfirm, Tag } from 'antd';
import RemedyEditor, { queryLanguageFor } from '../util/monaco-remedy';

const { Panel } = Collapse;

const sameConnector = (a, b) => (a || 'remedy') === (b || 'remedy');

/**
 * Editable panel for a deleteConfig entry: {form, query, description, connector?}
 */
const DeletePanel = ({ entry, allFields, index, onChange, onDelete, connectors }) => {
    const ql = queryLanguageFor(connectors, entry.connector);
    const found = allFields && allFields.find((af) => af.form === entry.form && sameConnector(af.connector, entry.connector));
    const formFields = found && found.fields;

    const genExtra = () => (
        <Popconfirm
            title={`Remove ${entry.form} from configuration?`}
            onConfirm={(e) => { e.stopPropagation(); onDelete(); }}
            onCancel={(e) => e.stopPropagation()}
        >
            <DeleteOutlined onClick={(event) => event.stopPropagation()} />
        </Popconfirm>
    );

    return (
        <div className="sc-entry danger" style={{marginBottom: 16}}>
        <Collapse ghost defaultActiveKey={['1']}>
            <Panel
                key={1}
                header={
                    <span>
                        <span className="etype" style={{fontWeight: 680, color: "var(--sc-danger)"}}>{entry.form}</span>
                        <Tag color="geekblue" style={{marginLeft: 8}}>{entry.connector || "remedy"}</Tag>
                        {entry.description && <span style={{marginLeft: 10, fontSize: 12, color: "var(--sc-ink-3)"}}>{entry.description}</span>}
                    </span>
                }
                extra={genExtra()}
            >
                <div style={{display: "flex", alignItems: "center", gap: 8, color: "var(--sc-danger)", fontWeight: 600, fontSize: 13, marginBottom: 12}}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>
                    All matching records are permanently deleted.
                </div>
                <div style={{fontSize: 12, color: "var(--sc-ink-3)", marginBottom: 4}}>Description</div>
                <Input
                    value={entry.description}
                    style={{ marginBottom: 8 }}
                    onChange={(e) => onChange({ ...entry, description: e.target.value })}
                />
                <div style={{fontSize: 12, color: "#cf1322", margin: "8px 0 4px"}}>Query ({ql.name}) — all matching records will be DELETED</div>
                <RemedyEditor
                    queryLanguage={ql}
                    key={`delete-bq-editor-${index}`}
                    height={'60px'}
                    minimap={{ enabled: false }}
                    defaultValue={entry.query}
                    formFields={formFields}
                    form={entry.form}
                    onChange={(v) => onChange({ ...entry, query: v })}
                />
                <div className="sc-muted" style={{fontSize: 12.5, marginTop: 10}}>
                    Always dry-run first — it safely counts <b>“would delete N”</b> before a single record is removed.
                </div>
            </Panel>
        </Collapse>
        </div>
    );
};

export default DeletePanel;
